import React from "react";
import Hero from "./Hero";
import { useContentFieldValue } from "../../../helpers/hooks/useContentFieldValue";
import { HeroWithSearch } from "./HeroWithSearch";

const HeroBlockSwitch = (props) => {
    const searchForm = useContentFieldValue(
        "ShowSearchForm",
        props.contentFields
    );
    return searchForm ? <HeroWithSearch {...props} /> : <Hero {...props} />;
};

export default HeroBlockSwitch;



// WEBPACK FOOTER //
// ./src/frontend/components/Fields/Hero/index.js